var Handlebars = require('/Users/najeeb/Applications/Project/starzhtml5player/node_modules/handlebars/runtime.js');
module.exports = (Handlebars['default'] || Handlebars).template({"1":function(container,depth0,helpers,partials,data,blockParams,depths) {
    var helper, alias1=depth0 != null ? depth0 : (container.nullContext || {}), alias2=container.hooks.helperMissing, alias3="function", alias4=container.escapeExpression, lookupProperty = container.lookupProperty || function(parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }
        return undefined
    };

  return "    <li class=\"seasonSel-item\"><a href=\"#\" data-season-number=\""
    + alias4(((helper = (helper = lookupProperty(helpers,"tvSeasonNumber") || (depth0 != null ? lookupProperty(depth0,"tvSeasonNumber") : depth0)) != null ? helper : alias2),(typeof helper === alias3 ? helper.call(alias1,{"name":"tvSeasonNumber","hash":{},"data":data,"loc":{"start":{"line":3,"column":63},"end":{"line":3,"column":81}}}) : helper)))
    + "\" class=\"seasonSel-item-link\">"
    + alias4(container.lambda((depths[1] != null ? lookupProperty(depths[1],"season") : depths[1]), depth0))
    + " "
    + alias4(((helper = (helper = lookupProperty(helpers,"tvSeasonNumber") || (depth0 != null ? lookupProperty(depth0,"tvSeasonNumber") : depth0)) != null ? helper : alias2),(typeof helper === alias3 ? helper.call(alias1,{"name":"tvSeasonNumber","hash":{},"data":data,"loc":{"start":{"line":3,"column":125},"end":{"line":3,"column":143}}}) : helper)))
    + "</a></li>\n";
},"compiler":[8,">= 4.3.0"],"main":function(container,depth0,helpers,partials,data,blockParams,depths) {
    var stack1, lookupProperty = container.lookupProperty || function(parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }
        return undefined
    };

  return ((stack1 = lookupProperty(helpers,"each").call(depth0 != null ? depth0 : (container.nullContext || {}),(depth0 != null ? lookupProperty(depth0,"titles") : depth0),{"name":"each","hash":{},"fn":container.program(1, data, 0, blockParams, depths),"inverse":container.noop,"data":data,"loc":{"start":{"line":2,"column":0},"end":{"line":4,"column":9}}})) != null ? stack1 : "");
},"useData":true,"useDepths":true});


//////////////////
// WEBPACK FOOTER
// ./src/modules/episode_selector/series_list.hbs
// module id = 419
// module chunks = 0